var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expansion-panel",class:{ 'is-expanded': _vm.value }},[_c('div',{staticClass:"expansion-panel__content"},[_vm._t("default")],2),_c('div',{ref:"expandableRef",staticClass:"expandable"},[_c('div',{staticClass:"expandable__content"},[_vm._t("expandable")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }